import { ActionReducerMap } from '@ngrx/store';
import * as fromCompArrayFormClients from '../../comp-array-form-clients/store';
import * as fromConfirmedMessage from '../../confirmed-message/store';
import * as fromPerfilUsuario from '../../perfil-usuario/store';
import * as fromSearchUser from '../../search-user/store';
import * as fromVisualizarUsuario from '../../visualizar-usuario/store';
import * as fromAccessProfile from '../../access-profile/store';
import * as fromConsultaClientes from '../../consulta-clientes/store';
import * as fromConsultaUsuarios from '../../consulta-usuarios/store';
import * as fromCreateUserWizard from '../../create-user-wizard/store';
import * as fromCreateUser from '../../create-user/store';
import * as fromEdit0 from '../../edit-0/store';
import * as fromEdit1 from '../../edit-1/store';
import * as fromEdit5 from '../../edit-5/store';
import * as fromFundos from '../../fundos/store';
import * as fromMasterHome from '../../master-home/store';
import * as fromPerfilAcesso from '../../perfil-acesso/store';
import * as fromSearch0 from '../../search-0/store';
import * as fromSearch1 from '../../search-1/store';

import * as fromRoot from '@core/store';

export interface MasterState {
  CompArrayFormClients: fromCompArrayFormClients.State;
  ConfirmedMessage: fromConfirmedMessage.State;
  PerfilUsuario: fromPerfilUsuario.State;
  SearchUser: fromSearchUser.State;
  VisualizarUsuario: fromVisualizarUsuario.State;
  AccessProfile: fromAccessProfile.State;
  ConsultaClientes: fromConsultaClientes.State;
  ConsultaUsuarios: fromConsultaUsuarios.State;
  CreateUserWizard: fromCreateUserWizard.State;
  CreateUser: fromCreateUser.State;
  Edit0: fromEdit0.State;
  Edit1: fromEdit1.State;
  Edit5: fromEdit5.State;
  Fundos: fromFundos.State;
  MasterHome: fromMasterHome.State;
  PerfilAcesso: fromPerfilAcesso.State;
  Search0: fromSearch0.State;
  Search1: fromSearch1.State;
}
// Master feature reducers
export const reducers: ActionReducerMap<MasterState, any> = {
  CompArrayFormClients: fromCompArrayFormClients.reducer,
  ConfirmedMessage: fromConfirmedMessage.reducer,
  PerfilUsuario: fromPerfilUsuario.reducer,
  SearchUser: fromSearchUser.reducer,
  VisualizarUsuario: fromVisualizarUsuario.reducer,
  AccessProfile: fromAccessProfile.reducer,
  ConsultaClientes: fromConsultaClientes.reducer,
  ConsultaUsuarios: fromConsultaUsuarios.reducer,
  CreateUserWizard: fromCreateUserWizard.reducer,
  CreateUser: fromCreateUser.reducer,
  Edit0: fromEdit0.reducer,
  Edit1: fromEdit1.reducer,
  Edit5: fromEdit5.reducer,
  Fundos: fromFundos.reducer,
  MasterHome: fromMasterHome.reducer,
  PerfilAcesso: fromPerfilAcesso.reducer,
  Search0: fromSearch0.reducer,
  Search1: fromSearch1.reducer,
};
